export default "__VITE_ASSET__7f38983e__"